export function useTyping() {
  const isKorean = (lang) => lang === 'ko';

  const getNextChar = (targetChar, currentInput, language) => {
    if (!targetChar) return null;
    
    if (isKorean(language)) {
      // 한글의 경우 자모 분해를 통해 다음 입력할 문자 결정
      return getNextKoreanChar(targetChar, currentInput || '');
    } else {
      // 영어의 경우 단순히 다음 문자
      if (!currentInput) {
        return targetChar[0];
      }
      if (currentInput.length < targetChar.length) {
        return targetChar[currentInput.length];
      }
      return null;
    }
  };

  const getNextKoreanChar = (targetChar, currentInput) => {
    // 현재 입력이 타겟과 일치하면 완성
    if (currentInput === targetChar) {
      return null;
    }

    // 공주 단어의 단계별 처리
    if (targetChar === 'ㄱ') {
      return currentInput === '' ? 'ㄱ' : null;
    }
    if (targetChar === '고') {
      if (currentInput === '') return 'ㄱ';
      if (currentInput === 'ㄱ') return 'ㅗ';
      return null;
    }
    if (targetChar === '공') {
      if (currentInput === '') return 'ㄱ';
      if (currentInput === 'ㄱ') return 'ㅗ';
      if (currentInput === 'ㄱㅗ') return 'ㅇ';
      return null;
    }
    if (targetChar === '공ㅈ') {
      if (currentInput === '') return 'ㄱ';
      if (currentInput === 'ㄱ') return 'ㅗ';
      if (currentInput === 'ㄱㅗ') return 'ㅇ';
      if (currentInput === 'ㄱㅗㅇ') return 'ㅈ';
      return null;
    }
    if (targetChar === '공주') {
      if (currentInput === '') return 'ㄱ';
      if (currentInput === 'ㄱ') return 'ㅗ';
      if (currentInput === 'ㄱㅗ') return 'ㅇ';
      if (currentInput === 'ㄱㅗㅇ') return 'ㅈ';
      if (currentInput === 'ㄱㅗㅇㅈ') return 'ㅜ';
      return null;
    }

    // 나무 단어의 단계별 처리
    if (targetChar === 'ㄴ') {
      return currentInput === '' ? 'ㄴ' : null;
    }
    if (targetChar === '나') {
      if (currentInput === '') return 'ㄴ';
      if (currentInput === 'ㄴ') return 'ㅏ';
      return null;
    }
    if (targetChar === '남') {
      if (currentInput === '') return 'ㄴ';
      if (currentInput === 'ㄴ') return 'ㅏ';
      if (currentInput === 'ㄴㅏ') return 'ㅁ';
      return null;
    }
    if (targetChar === '나무') {
      if (currentInput === '') return 'ㄴ';
      if (currentInput === 'ㄴ') return 'ㅏ';
      if (currentInput === 'ㄴㅏ') return 'ㅁ';
      if (currentInput === 'ㄴㅏㅁ') return 'ㅜ';
      return null;
    }
    
    return null;
  };

  const combineHangul = (cho, jung, jong = null) => {
    const choIndex = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ'.indexOf(cho);
    const jungIndex = 'ㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣ'.indexOf(jung);
    const jongIndex = jong ? 'ㄱㄲㄳㄴㄵㄶㄷㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅄㅅㅆㅇㅈㅊㅋㅌㅍㅎ'.indexOf(jong) + 1 : 0;

    if (choIndex === -1 || jungIndex === -1) return null;

    const unicode = 0xAC00 + (choIndex * 21 * 28) + (jungIndex * 28) + jongIndex;
    return String.fromCharCode(unicode);
  };

  const decomposeHangul = (char) => {
    const charCode = char.charCodeAt(0);
    if (charCode < 0xAC00 || charCode > 0xD7A3) {
      return { cho: char, jung: null, jong: null };
    }

    const offset = charCode - 0xAC00;
    const jongIndex = offset % 28;
    const jungIndex = ((offset - jongIndex) / 28) % 21;
    const choIndex = (((offset - jongIndex) / 28) - jungIndex) / 21;

    const cho = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ'[choIndex];
    const jung = 'ㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣ'[jungIndex];
    const jong = jongIndex > 0 ? 'ㄱㄲㄳㄴㄵㄶㄷㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅄㅅㅆㅇㅈㅊㅋㅌㅍㅎ'[jongIndex - 1] : null;

    return { cho, jung, jong };
  };

  return {
    isKorean,
    getNextChar,
    combineHangul,
    decomposeHangul
  };
}